import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArquivoService {

  constructor(
    private http: HttpClient
  ) { }
  baseUrl = environment.baseUrl;
  
  public cadastrar(formData: FormData, clienteId: number|string|null): Observable<any> {
    const url = `${this.baseUrl}clientes/cliente/shapes/${clienteId}`;
    return this.http.post<any>(url, formData);
  }
}
